import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { NavigationEnd, Router } from '@angular/router';
import { FreeServicesRequestListService } from './free-services-request-list.service';
import { GkWindowRef } from '../gk-kendo';

@Component({
  selector: 'gk-free-services-request-list',
  templateUrl: './free-services-request-list.component.html',
  standalone: false,
})
export class FreeServicesRequestListComponent implements OnInit, OnDestroy {
  constructor(
    private router: Router,
    private freeServicesRequestListService: FreeServicesRequestListService,
  ) {}
  windowRef: GkWindowRef;
  urlSubscription!: Subscription;

  ngOnInit(): void {
    this.maybeCloseWindowByRoute();
  }

  maybeCloseWindowByRoute(): void {
    this.urlSubscription = this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        const currentUrl = event.url;

        if (!currentUrl.includes('free-services-portal/request-list')) {
          this.windowRef.close();
        }
      }
    });
  }

  public handleGeomFilter(geom: string): void {
    this.freeServicesRequestListService.geomPointFromMap.next(geom);
  }

  ngOnDestroy(): void {
    if (this.urlSubscription) {
      this.urlSubscription.unsubscribe();
    }
  }
}
